import Accordion from 'accordion-js';

export default () => {
    new Accordion('.accordionCont');
}